import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';

import Spinner from '@johnlewispartnership/wtr-ingredients/dist/Spinner';
import { Trolley } from '@johnlewispartnership/wtr-style-dictionary/icons/react/Trolley';
import { useMinSpend } from 'hooks/use-min-spend';
import styles from './TrolleyButtonContents.module.scss';

export const TrolleyButtonContents = ({
  estimatedCost,
  loadingStatus,
  hasTrolleyError,
  testIdSuffix,
}) => {
  const { showMinSpend } = useMinSpend();

  return (
    <div className={styles.buttonWrapper} data-trolley-loading={loadingStatus} aria-hidden="true">
      {loadingStatus && (
        <div className={styles.spinnerOverlay}>
          <Spinner isActive size="small" data-testid="spinner" />
        </div>
      )}
      <Trolley size="small" />
      <span
        className={classNames(styles.anchorText, { [styles.hasMinSpend]: showMinSpend })}
        data-testid={`total-price-overview${testIdSuffix ? `-${testIdSuffix}` : ''}`}
      >
        {hasTrolleyError ? 'Trolley' : estimatedCost}
      </span>
    </div>
  );
};

TrolleyButtonContents.propTypes = {
  estimatedCost: string,
  loadingStatus: bool,
  hasTrolleyError: bool,
  testIdSuffix: string,
};

TrolleyButtonContents.defaultProps = {
  estimatedCost: '',
  loadingStatus: false,
  hasTrolleyError: false,
  testIdSuffix: '',
};
